import { BUTTON_SIZE, DSButton, DSModal } from '@repo/design-system/index'
import { n_book_lessons, n_common } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'

interface TimeSlotUnavailableModalProps {
  isOpen: boolean
  onOpen: () => void
  onClick?: () => void
}

const TimeSlotUnavailableModal = ({ isOpen, onOpen, onClick = null }: TimeSlotUnavailableModalProps) => {
  const { t } = useTranslation()

  const handleConfirmClick = () => {
    onClick?.()
    window.location.reload()
  }

  return (
    <DSModal id="TimeSlotUnavailableModal" isOpen={isOpen} setIsOpen={onOpen} size={'lg'}>
      <DSModal.Content className="mt-[16px]">{t(n_book_lessons.not_available.content)}</DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton size={BUTTON_SIZE.LG} onClick={handleConfirmClick}>
          <DSButton.Label>{t(n_common.btn_ok)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export default TimeSlotUnavailableModal
